export default "__VITE_ASSET__DO6WeHPo__"